import { Component, Input, OnInit } from '@angular/core';
import { BackgroundModel, ButtonStyleModel, EventsService } from 'simpo-component-library';

@Component({
  selector: 'app-button-style-editor',
  templateUrl: './button-style-editor.component.html',
  styleUrls: ['./button-style-editor.component.scss']
})
export class ButtonStyleEditorComponent implements OnInit {
  constructor(private eventService: EventsService) {}

  @Input() buttonStyle!: ButtonStyleModel;
  @Input() id!: string;
  @Input() btnId!: string;
  @Input() color!: string;
  @Input() backgroundInfo?: BackgroundModel;

  // Typed accessor for extra properties not in ButtonStyleModel
  get bs(): any { return this.buttonStyle as any; }

  ngOnInit() {
    if (!this.buttonStyle.background) this.buttonStyle.background = '#000000';
    if (!this.buttonStyle.textColor) this.buttonStyle.textColor = '#FFFFFF';
    if (this.bs.borderColor === undefined) this.bs.borderColor = '#E5E7EB';
    if (this.bs.cornerRadius === undefined) this.bs.cornerRadius = 8;
    if (this.bs.padding === undefined) this.bs.padding = { top: 14, right: 24, bottom: 14, left: 24 };
    if (this.bs.backgroundOpacity === undefined) this.bs.backgroundOpacity = 100;
    if (this.bs.textColorOpacity === undefined) this.bs.textColorOpacity = 100;
    if (this.bs.borderColorOpacity === undefined) this.bs.borderColorOpacity = 100;
  }

  setVariant(type: 'Solid' | 'Outline' | 'Text') {
    this.buttonStyle.type = type;
    this.emitChange();
  }

  emitChange() {
    this.eventService.buttonStyleChangeChecks.emit({
      id: this.id + this.btnId,
      style: this.buttonStyle,
      backgroundInfo: this.backgroundInfo
    });
  }
}
